import axios from "axios";
import { getDatosUsuariosLocalStorag } from "utils/DatosUsuarioLocalStorag";
import { clienteInfo } from "utils/DatosUsuarioLocalStorag";

export const GuardarLocalidad = async (parms) => {
    let id = clienteInfo() != null ? clienteInfo().id : 0
    let idop = clienteInfo() != null ? 0 : getDatosUsuariosLocalStorag().id
    //                                      getDatosUsuariosLocalStorag
    let parmspro = {
        "id_usuario": parseInt(idop),
        "id_operador": parseInt(id),
    }
    try{
        const { data } = await axios.post("https://api.t-ickets.com/ms_login/api/v1/guardar_localidad", {...parms,...parmspro}, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='


            }
        })
        return data
    }catch(err){
        // Antes se devolvia el error crudo de axios como si fuera "data" normal --
        // el caller solo revisaba `.success`, que no existe en un error de axios,
        // asi que fallaba en silencio sin dejar rastro de la causa real (status,
        // mensaje del backend). Ahora al menos queda logueado en la consola.
        console.error('[GuardarLocalidad] fallo el POST a guardar_localidad:', {
            status: err?.response?.status,
            data: err?.response?.data,
            message: err?.message,
        })
        return err?.response?.data || { success: false, message: err?.message || 'Error de red' }
    }

}
// Version scoped: trae solo las localidades del espacio pedido (el backend filtra
// por id_espacio), en vez de traer TODA la tabla de localidades de la plataforma
// como hace ListarLocalidad("") -- eso es lo que hacia lenta la carga al abrir
// cualquier espacio a medida que crecia el numero total de localidades del sistema.
export const ListarLocalidadPorEspacio = async (id_espacio) => {
    try{
        const { data } = await axios.get("https://api.t-ickets.com/ms_login/api/v1/listar_localidades_por_espacio/" + id_espacio, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        })
        return data
    }catch(err){
        return err
    }
}
export const ListarLocalidad = async (parms) => {
    try{
        const { data } = await axios.get("https://api.t-ickets.com/ms_login/api/v1/listar_localidades/" + parms, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        })
        return data
    }catch(err){
        return err
    }
  
}